import { Body2, Heading4, Image } from '@cian/ui-kit';
import * as React from 'react';

import styles from './SellersBannerCarouselSlide.css';
import { Underground } from './components/Underground';

import type { ISpecialPromoSecondaryOfferSnippetSchema } from '../../types/specialPromoSecondaryOffers';

type TProps = {
  offer: ISpecialPromoSecondaryOfferSnippetSchema;
  source: string;
  onClick: () => void;
};

export const SellersBannerCarouselSlide: React.FC<TProps> = ({ offer, source, onClick }) => {
  const { imageUrl, cardUrl, priceDisplay, description, address, underground } = offer;

  return (
    <a
      className={styles['container']}
      target="_blank"
      href={`${cardUrl}?source=${source}`}
      rel="noopener noreferrer"
      onClick={onClick}
    >
      <Image src={imageUrl} width="100%" height={140} objectFit="cover" borderRadius={0} />
      <div className={styles['content']}>
        <Heading4>{priceDisplay}</Heading4>
        <Body2>{description}</Body2>
        {underground && <Underground underground={underground} />}
        <Body2 color="text-secondary-default" ellipsis>
          {address}
        </Body2>
      </div>
    </a>
  );
};
